var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 39780"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 422",
    cx: 10.1755,
    cy: 10.7559,
    r: 10,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 4",
    d: "M7.34717 7.92773L13.004 13.5846",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 5",
    d: "M13.0039 7.92773L7.34705 13.5846",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.fd83206f4c2dd92c4ba1d915090b9669.svg";
export { ForwardRef as ReactComponent };